<template>
    <drawer-layout>
        <div class="report-container mx-7 mt-4">
            <control-panel
                :breadcrumbs="breadcrumbsItems"
                :title="$t('reports.reports')"
            />

            <report-card
                :report="currentReport"
                :type="reportType"
            />
        </div>
    </drawer-layout>

</template>

<script>
import {ReportModelFactory} from "@/Repositories/Reports/Factories/ReportModelFactory";
import DrawerLayout from "@/Shared/DrawerLayout";
import ControlPanel from "@/Shared/ControlPanel";
import {i18n} from "@/i18n";
import ReportCard from "@/Shared/Reports/Show/ReportCard";
import _ from "lodash";

export default {
    name: "Show",

    components: {ReportCard, DrawerLayout, ControlPanel},

    props: {
        reportType: {
            type: Object,
            required: true,
        },
        report: {
            type: Object,
            default: {}
        },
    },

    data() {
        return {
            currentReport: new ReportModelFactory(this.reportType.name),
        }
    },

    methods: {

        /**
         *
         */
        cloneReport() {
            this.currentReport = _.cloneDeep(this.report);
        },

        /**
         * Refresh Report data after an update is performed
         *
         * @param Report
         */
        updateReport(Report) {
            this.currentReport = _.cloneDeep(Report);
        }
    },

    computed: {

        /**
         *
         * @returns {*}
         */
        reportTitle() {
            return this.currentReport?.title;
        },

        /**
         *
         * @returns {[{disabled: boolean, text},{disabled: boolean, text: *, href: *},{disabled: boolean, text: *}]}
         */
        breadcrumbsItems() {
            return [
                {
                    text: i18n.t(`reports.types.${this.reportTypeRouteParameter}`),
                    disabled: true,
                },
                {
                    text: i18n.t('reports.list'),
                    disabled: false,
                    href: route('reports.index', {type: this.reportTypeRouteParameter}),
                },
                {
                    text: this.reportTitle,
                    disabled: true,
                },
            ];
        },

        /**
         *
         * @returns {*}
         */
        reportTypeRouteParameter() {
            return _.get(this.reportType, 'route_type_parameter');
        }
    },

    created() {
        this.cloneReport();

        this.$root.$on('reports.management.report_updated', this.updateReport);
    }
}
</script>

<style scoped>

</style>
